import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { Eye, EyeOff } from "lucide-react"; // React icons from Lucide
import "./Login.css";

const Login = () => {
  const [authId, setAuthId] = useState("admin");
  const [password, setPassword] = useState("admin123");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const result = await login(authId, password);

    if (!result.success) {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-blob login-blob--one" />
      <div className="login-blob login-blob--two" />

      <div className="login-card">
        <div className="login-logo">M</div>
        <div className="login-header">
          <h2>Welcome</h2>
          <p>Sign in to continue to Master Project</p>
          <div style={{
            fontSize: "12px",
            color: "#4b5563",
            background: "#f3f4f6",
            padding: "6px 12px",
            borderRadius: "6px",
            marginTop: "10px",
            border: "1px dashed #d1d5db",
            display: "inline-block"
          }}>
            Static login: <strong>admin</strong> / <strong>admin123</strong>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="authId">User ID</label>
            <input
              type="text"
              id="authId"
              value={authId}
              onChange={(e) => setAuthId(e.target.value)}
              placeholder="Enter your user ID"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="password-container">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          {error && <div className="error-message">{error}</div>}

          <button className="button-color" type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Login"}
          </button>
        </form>

        {/* <div className="login-footer">
          <span>Need help? Contact support.</span>
        </div> */}
      </div>
    </div>
  );
};

export default Login;
